// extracted by mini-css-extract-plugin
export default {"row":"EventOfferPerMultipleTickets_row__vYdJJ","wrapper":"EventOfferPerMultipleTickets_wrapper__qzU2O","item":"EventOfferPerMultipleTickets_item__t2yAC"};